import type { VariationComponent } from "~types/types";
import type { IntegrityStatus } from "~utils/moduleIntegrity";

export default function integrityCheck(
    _props: VariationComponent
): IntegrityStatus {
    // TODO [ENG4AUD-570]: implement while connecting to wardenclyffe
    // const REQUIRED_PROPERTIES: ["title", "slug"] = ["title", "slug"];
    // const errorMessages = [];
    // for (const item of records) {
    //     errorMessages = [
    //         ...errorMessages,
    //         ...REQUIRED_PROPERTIES.map((property) => {
    //             if (!item[property]) {
    //                 return `Missing ${property.toString()}`;
    //             }
    //             return null;
    //         }).filter(truthyFilter),
    //     ];
    // }

    // return errorMessages;
    return [];
}
